import { useEffect } from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Landing from "@/components/site/Landing";
import MenuPage from "@/components/site/MenuPage";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";
import ResetPassword from "@/components/admin/ResetPassword";

function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
        else if (attempt < 10) setTimeout(() => tryScroll(attempt + 1), 100);
      };
      tryScroll();
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    const base = "Palace of Flavor";
    let title = `${base} | Authentic Indian & Pakistani Catering in Tampa Bay`;
    if (pathname.startsWith("/menu")) title = `Catering Menu | ${base}`;
    else if (pathname.startsWith("/admin")) title = `Admin | ${base}`;
    document.title = title;
  }, [pathname]);

  return (
    <>
      <ScrollToHash />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/reset-password" element={<ResetPassword />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App bg-pof min-h-screen">
        <div className="grain-overlay" />
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" />
      </div>
    </ReactLenis>
  );
}

export default App;
